export default __webpack_public_path__ + "static/media/puzzle6.660789c0.svg";